import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RejectWithMessage } from 'features/types';
import { getErrorMessage } from 'utils/error';
import { ResourceDetails, ResourceDetailsState, GetResourceDetailsTypes } from './types';
import { resourcesAPI } from 'api';

export const getDetails = createAsyncThunk<ResourceDetails, { id: string, getResourceDetailsType: GetResourceDetailsTypes }, RejectWithMessage>(
  'resource-details/get',
  async (params, { rejectWithValue }) => {
    try {
      return await resourcesAPI.getDetails(params.id, params.getResourceDetailsType);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const initialState: ResourceDetailsState = {
  status: 'idle',
  error: null,
  data: {
    details: null,
  }
};

const resourceDetailsSlice = createSlice({
  name: 'resource-details',
  initialState,
  reducers: {
    setDetails: (state, action: PayloadAction<ResourceDetails>) => {
      if (state.data?.details) {
        state.data.details = action.payload;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getDetails.pending, (state) => {
      state.status = 'pending';
    });
    builder.addCase(getDetails.fulfilled, (state, action: PayloadAction<ResourceDetails>) => {
      state.status = 'fulfilled';
      state.data.details = action.payload;
      state.error = null;
    });
    builder.addCase(getDetails.rejected, (state) => {
      state.status = 'rejected';
    });
  }
});
export const { setDetails } = resourceDetailsSlice.actions;

export const resourceDetailsReducer = resourceDetailsSlice.reducer;
